module.exports = __webpack_public_path__ + "static/productPeriodImage-f05e01c46e8454bf7fa905ecc5e825a2.png";